import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import Strings from "@my-dld/assets/strings";
import { replaceNavigate } from "@my-dld/utils/StoreUtils";
import PageTitle from "@my-dld/components/PageTitle";
import { DashboardBCItem, MyProfileBCItem } from "@my-dld/contexts/PageContext";
import PageContent from "@my-dld/components/PageContent";
import TextInputField from "@my-dld/components/Form/TextInputField";
import { I8N, StringUtil } from "@eres/core";
import { SSOApi } from "@eres/ssoapi";
import { exToMessage } from "@eres/ssoapi/api";
import { hideLoading, showLoading } from "@my-dld/utils/UIUtils";
import { PasswordMeter, validateNewPassword } from "./ChangePassword";
import { SSOApp } from "../../../../typings/global";

interface Props extends RoutedViewProps {

}

interface State {
	userName: string;
	password: string;
	newPwdConfirm: string;
	formErrors: { [ k: string ]: string | undefined };
	app?: SSOApp;
}

export default class NewAccount extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		let appId = this.props.location && this.props.location.state && this.props.location.state.appId;
		let app = undefined;
		if ( appId != null ) {
			app = window.ssoApps.find( x => x.id === appId );
		}
		this.state = {
			userName: "",
			password: "",
			newPwdConfirm: "",
			formErrors: {},
			app: app,
		};
	}

	isValid = () => {
		let isError = StringUtil.isEmptyStringOrNull( this.state.userName );
		isError = isError || StringUtil.isEmptyStringOrNull( this.state.password );
		isError = isError || StringUtil.isEmptyStringOrNull( this.state.newPwdConfirm );
		if ( !isError ) {
			const evs = Object.values( this.state.formErrors );
			isError = evs.filter( x => !StringUtil.isEmptyStringOrNull( x ) ).length !== 0;
		}
		return !isError;
	};

	render() {
		const isValid = this.isValid();
		const { app, formErrors } = this.state;
		// if (app == null)
		//     return <Redirect to={ "/mydld" }/>
		const formProps = {
			containerClassName: "form-group mb-4 field-style",
			inputClassName: "form-control",
			holder: this,
		};
		return <PageContent title={ Strings.create_account }>
			<PageTitle title={ Strings.create_account } paths={ [ DashboardBCItem, MyProfileBCItem ] }/>
			<div className="row change-password-wrapper">
				<div className={ "col-md-12" }>
					<div className="change-password-title">
						<h5>{ Strings.sso_link_fail_create_new_user_id }</h5>
					</div>
					<TextInputField
						{ ...formProps }
						placeHolder={ Strings.username_placeholder }
						id={ "userName" }
						error={ formErrors.userName }
						label={ Strings.user_name }
						required={ true }
						maxLength={ 250 }
						onValueChange={ ( value, extra ) => {
							this.validateUserName( value );
						} }
					>
					</TextInputField>


					<TextInputField
						{ ...formProps }
						placeHolder={ Strings.new_password }
						id={ "password" }
						error={ this.state.formErrors.password }
						label={ Strings.new_password }
						required={ true }
						maxLength={ 250 }
						inputProps={ {
							type: "password"
						} }
						onValueChange={ ( value, extra ) => {
							this.validatePwd( value );
						} }
						onValueUpdated={ ( value: string ) => {
							if ( !StringUtil.isEmptyStringOrNull( this.state.newPwdConfirm ) )
								this.validateConfirmPwd( this.state.newPwdConfirm );
						} }
					>
						<PasswordMeter value={ this.state.password }/>
					</TextInputField>

					<TextInputField
						{ ...formProps }
						placeHolder={ Strings.confirm_new_password }
						id={ "newPwdConfirm" }
						error={ this.state.formErrors.newPwdConfirm }
						label={ Strings.confirm_new_password }
						required={ true }
						maxLength={ 250 }
						inputProps={ {
							type: "password"
						} }
						onValueChange={ ( value, extra ) => {
							this.validateConfirmPwd( value );
						} }
					/>

					<div className="form-group">
						<button
							disabled={ !isValid } type="button" onClick={ this.submit }
							className="btn btn_1">{ Strings.submit_label }</button>
						<a href="#/mydld/profile" className="ms-3 me-3">{ Strings.cancel }</a>
					</div>
				</div>
			</div>

		</PageContent>;
	}

	setError = ( key: string, error: string | undefined ) => {
		this.setState( s => {
			return {
				formErrors: {
					...s.formErrors,
					[ key ]: error,
				}
			};
		} );
	};
	validateUserName = ( value: string ) => {
		if ( StringUtil.isEmptyStringOrNull( value ) ) {
			this.setError( "userName", Strings.form_required_label );
		} else {
			this.setError( "userName", undefined );
		}
	};
	validatePwd = ( value: string ) => {
		if ( StringUtil.isEmptyStringOrNull( value ) ) {
			this.setError( "password", Strings.form_required_label );
		} else {
			try {
				validateNewPassword( value );
				this.setError( "password", undefined );
			} catch ( e ) {
				this.setError( "password", Strings.password_req_fail );
			}
		}
	};
	validateConfirmPwd = ( value: string ) => {
		if ( value !== this.state.password ) {
			this.setError( "newPwdConfirm", Strings.passwords_doesnt_match );
		} else {
			this.setError( "newPwdConfirm", undefined );
		}
	};
	submit = () => {
		showLoading();
		let app = this.state.app!;
		SSOApi.profile.copy( app.id, this.state.userName, this.state.password )
		.then( r => {
			hideLoading();
			replaceNavigate( "/mydld" );
			window.open( app?.signUpUrl + "?ln=" + I8N.locale(), "_" + app.id );
		} )
		.catch( e => {
			hideLoading();
			exToMessage( e ).then( message => {
				let key = "userName";
				if ( message.src ) {
					key = message.src;
				}
				this.setError( key, message.error );
			} );
		} );
	};
}
